import axios from 'axios';
import { AppMap } from '../utils/AppMap';
import mapResponseData from './mapResponseData';

const handleDeleteOwnArea = ({ id, code, areaId, areaArray, setAreaArray, setLock }) => {

    const url = `https://api.lightpass.gradis.pl/api/requests/${id}/${code}/areas/${areaId}`;
    setLock(true);

    const areaToDelete = areaArray.find((area) => area.area_id === areaId);
    console.log("Area array: ", areaArray);
    console.log("Deleting area: ", areaToDelete);
    
    axios.delete(url, {
        headers: {
            'Accept-Language': localStorage.getItem("language") || "pl"
        }
    }).then((response) => {

        AppMap.clearPolygonByAreaId(areaId);
        console.log("Area deleted: ", response);

        const updatedAreaArray = mapResponseData(response);
        console.log("Updated area array: ", updatedAreaArray);
        localStorage.setItem('areaArray', JSON.stringify(updatedAreaArray));
        setAreaArray(updatedAreaArray);
        AppMap.drawMultiple(updatedAreaArray);
        
    }).catch((error) => {
        console.error("Area delete error: ", error);
    }).finally(() => {
        setLock(false);
    });
}   

export default handleDeleteOwnArea;